

export const returnProfilDesignation = () => {
  const PROFIL = localStorage.getItem("user_profil")
  ? JSON.parse(localStorage.getItem("user_profil"))
  : null;
  return PROFIL ? PROFIL.designation : null;
};

export const returnMenuVisible = () => {
  const PROFIL = localStorage.getItem("user_profil")
  ? JSON.parse(localStorage.getItem("user_profil"))
  : null;

  return PROFIL ? PROFIL.menusPermissions : null;
};

export const returnPermissionsParMenu = (route) => {
  const PROFIL = localStorage.getItem("user_profil")
  ? JSON.parse(localStorage.getItem("user_profil"))
  : null;
  
  let listePermissions = [];
  if (PROFIL) {
    PROFIL.menusPermissions.forEach((element) => {
      if (element.menu.route === route) {
        listePermissions = element.permissions;
      }
    });
  }
  return listePermissions;
};

export const verificationPermissionsExistantes = (
  listePermissions,
  permission
) => {
  let hasPermission = false;
  listePermissions.map((item) => {
    if (item.designation === permission) {
      hasPermission = true;
    }
  });
  return hasPermission;
};
